import { render } from "./appointments.vue?vue&type=template&id=6896848c&scoped=true"
import script from "./appointments.vue?vue&type=script&lang=js"
export * from "./appointments.vue?vue&type=script&lang=js"

import "./appointments.vue?vue&type=style&index=0&id=6896848c&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6896848c"]])

export default __exports__